import { render, staticRenderFns } from "./RecedeEdit.vue?vue&type=template&id=b883a598&scoped=true&"
import script from "./RecedeEdit.vue?vue&type=script&lang=js&"
export * from "./RecedeEdit.vue?vue&type=script&lang=js&"
import style0 from "./RecedeEdit.vue?vue&type=style&index=0&id=b883a598&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b883a598",
  null
  
)

export default component.exports